import _ from 'lodash';


export default (bottle) => {
  bottle.factory('search', ({ termsFromJson }) => function search(term, source) {
    if (!term) {
      return true;
    }
    if (!(typeof term === 'string')) {
      throw new Error('bad search term ');
    }

    if (Array.isArray(source)) {
      return source.filter(item => search(term, item, true));
    }

    const searchTerm = term.toLowerCase();
    if (typeof source === 'string') {
      return source.toLowerCase().includes(searchTerm);
    }
    return termsFromJson(source).includes(searchTerm);
  });

  bottle.factory('termsFromJson', () => {
    function objectTerms(object) {
      // eslint-disable-next-line no-use-before-define
      return Object.keys(object).map(field => termsByType(object[field]));
    }

    function termsByType(object) {
      if (Array.isArray(object)) {
        return object.map(termsByType);
      }
      if (typeof object === 'object') {
        if (object instanceof Date) {
          return [object.toISOString()];
        }
        return objectTerms(object);
      }
      return [`${object}`];
    }

    function termsFromJson(object, sep = '\t') {
      return _.flattenDeep(termsByType(object)).join(sep).toLowerCase();
    }

    return termsFromJson;
  });
};
